<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">Organizations</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <form ref="myFormSave" @submit.prevent="saveAdd()">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Edit Organizations</h4>
          <b-button v-b-modal.modal-1 variant="primary" @click="confirmAndCloseModal">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" class="ml-1">
            Save
          </b-button>
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Code</label>
                  <input name="code" type="text" required class="form-control" v-model="payload.code" aria-required="true" />
                </div>
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" required class="form-control" v-model="payload.name" aria-required="true" />
                </div>
                <div class="form-group">
                  <label>Company</label>
                  <input name="name" type="text" required class="form-control" value="7003" disabled />
                </div>
              </div>
              <div class="col-12 m-2">
                <b-card class="p-0 m-0">
                  <b-card-header class="p-0 m-0">
                    <div><b>Budget Plan</b></div>
                  </b-card-header>
                  <b-card-body class="p-0 m-0">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <td class="text-center" width="20">No.</td>
                        <td width="100">Title</td>
                        <!--                        <td width="100">Total</td>-->
                        <td width="100">Year</td>
                        <td width="100">Department</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="listBudgetPlan" v-for="(item, index) in listBudgetPlan" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.title }}</td>
                        <!--                        <td>{{ item.total }}</td>-->
                        <td>{{ item.year }}</td>
                        <td>{{ item?.fund_center?.department_name }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <!--                        <vue-good-table :line-numbers="true" :columns="columns" :rows="listBudgetPlan" style-class="vgt-table border-0 table font-datatable" @on-page-change="onPageChange"
                                                           >
                                              &lt;!&ndash; Loading &ndash;&gt;
                                              <div slot="emptystate" class="text-center font-size-14">
                                                No data available
                                              </div>
                                            </vue-good-table>-->
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import index from "vuex";
import axiosIns from "@/api/axios";

export default {
  name: "ListUser",
  components: {ToggleSwitch},
  computed: {
    /*detail() {
      this.$store.getters["masterOrgChart/detail"];
    },*/
  },
  data() {
    return {
      payload: {
        code: "",
        name: "",
        is_divisi: false,
        company_code: "7003",
        parent_id: "",
      },
      divisi_id: "",
      department_id: "",
      role_id: "",
      id: "",
      isAdd: true,
      isLoading: false,
      listCompany: [],
      listDepartement: [],
      listDepartement_:[],
      listMember: [],
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,
      listBudgetPlan: [],
    };
  },

  mounted() {
    this.getDetail();
    /*this.getListCompany();*/
    this.getListDepartment();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    /*async getListCompany() {
      try {
        const response = await axiosIns.get("/master-org-chart/company-list");
        //console.log("response: ", response.data.data);
        this.listCompany = response.data.data.map(items => ({
          label: items.company_name,
          value: items.company_code
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },*/
    async getListDepartment() {
      try {
        const response = await axiosIns.get("/master-org-chart/divisi");
        this.listDepartement = response.data.data.map(items => ({
          label: items.name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },

    btnBack() {
      this.$router.push(`/master-data/org-chart`)
    },
    confirmAndCloseModal() {
      this.$swal({
        title: 'Confirm Close?',
        text: 'Are you sure you want to close this page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide('modal-1');
          this.$router.push(`/master-data/org-chart`)
        }
      });
    },
    saveAdd() {
      try {
        const id = this.$router.currentRoute.query.id;
        this.isLoading = true;
        this.payload.parent_id = !this.payload.is_divisi ? this.payload.parent_id : null;
        let param = {
          id: id,
          body: this.payload
        }
        this.$store
            .dispatch("masterOrgChart/UPDATE_DATA", param)
            .then((resp) => {
              this.$swal("Saved", "Your input has been saved", "success").then(
                  (resp) => {
                    this.isLoading = false;
                    this.$bvModal.hide("modal-1");
                    this.$router.push(`/master-data/org-chart`)
                  }
              );
            });
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },
    async getDetail() {
      const id = this.$router.currentRoute.query.id;
      this.id = this.$router.currentRoute.query.id;
      try {
        const response = await axiosIns.get("/master-org-chart/"+ id).then(async response => {
          console.log("response data: ", response.data.data[0]);
          // handle success
          this.payload.code = response.data.data[0]?.code;
          this.payload.name = response.data.data[0]?.name;
          this.payload.company_code = response.data.data[0]?.company_code;
          this.payload.is_divisi = response.data.data[0]?.is_divisi;
          this.payload.parent_id = response.data.data[0]?.parent_id;

          if (response.data.data[0]?.code) {
            const org_chart_payload = response.data.data[0]?.code
            const responseOrgChart = await axiosIns.get(`/fund-center/code/${org_chart_payload}`);
            this.listBudgetPlan = responseOrgChart.data.data;
            //console.log("responseOrgChart: ", responseOrgChart.data.data);
          } else {
            this.listBudgetPlan = []
          }


          /*if(response?.data?.data[0]?.childs.length > 0){
            this.payload.is_divisi = true;
            this.listDepartement_ = response?.data?.data[0]?.childs.map(items => ({
              label: items.name,
              value: items.id
            }));
          }
          if(response?.data?.data[0]?.members.length > 0){
            this.listMember = response?.data?.data[0]?.members.map(items => ({
              label: items.fullname,
              value: items.id
            }));
          }*/

        })
            .catch(error => {
              // handle error
              console.error('Error:', error)
            });


      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }




    },
  },
};
</script>
